import { translate, getTrackingService, FeatureEnabledV2, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import { Feature } from '@gig/magic-messages';
import { getStoredUsername, isUsernameStoreEnabled } from '../../../sign-up/sign-up.constants.js';
import { getInitialFormState } from '@gig/magic-form-builder';
import { translateCorexError } from '../../../../utils/translations.js';
import { getLoginFormConfig } from './form-config/login-form.config.js';

var KeycloakLogin = /** @class */ (function (_super) {
    __extends(KeycloakLogin, _super);
    function KeycloakLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Back home link and close icon feature
         */
        _this.isBackHomeLinkAndIconEnabled = false;
        _this.formConfig = null;
        _this.initialState = null;
        _this.submittedUsername = '';
        return _this;
    }
    Object.defineProperty(KeycloakLogin.prototype, "loginAction", {
        get: function () {
            return this.kcContext.url.loginAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakLogin.prototype, "loginResetCredentialsUrl", {
        get: function () {
            return (window.location.origin + this.kcContext.url.loginResetCredentialsUrl);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakLogin.prototype, "redirectUri", {
        get: function () {
            var urlParams = new URLSearchParams(window.location.search);
            var redirectUrl = urlParams.get('redirect_uri');
            if (!redirectUrl) {
                redirectUrl = window.location.origin;
            }
            return redirectUrl;
        },
        enumerable: false,
        configurable: true
    });
    KeycloakLogin.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, summary, type;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.createLoginForm()];
                    case 1:
                        _a.formConfig = _c.sent();
                        _b = this.kcContext.message || {}, summary = _b.summary, type = _b.type;
                        if (summary && type === 'info') {
                            this.sendNotification(summary);
                        }
                        this.handleLoginError();
                        return [2 /*return*/];
                }
            });
        });
    };
    KeycloakLogin.prototype.submit = function (value) {
        var form = this.$refs['login-form'];
        this.submittedUsername = value.username;
        this.getInput(form, 'username').value = value.username;
        this.getInput(form, 'password').value = value.password;
        form.submit();
    };
    KeycloakLogin.prototype.createLoginForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, summary, type, form, username, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.kcContext.message || {}, summary = _a.summary, type = _a.type;
                        return [4 /*yield*/, getLoginFormConfig(type === 'error' ? summary : undefined, type)];
                    case 1:
                        form = _c.sent();
                        username = getStoredUsername();
                        _b = username;
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, isUsernameStoreEnabled()];
                    case 2:
                        _b = (_c.sent());
                        _c.label = 3;
                    case 3:
                        if (_b) {
                            this.initialState = getInitialFormState([['username', username]]);
                        }
                        return [2 /*return*/, form];
                }
            });
        });
    };
    /**
     * Update form configuration with a new error message
     */
    KeycloakLogin.prototype.updateFormWithError = function (errorMessage) {
        if (this.formConfig && this.formConfig.length > 0) {
            this.formConfig[0].errorMessage = errorMessage;
            this.formConfig[0].alwaysShowErrorMessage = true;
        }
    };
    /**
     * Clear error message from form configuration
     */
    KeycloakLogin.prototype.clearFormError = function () {
        if (this.formConfig && this.formConfig.length > 0) {
            this.formConfig[0].errorMessage = undefined;
            this.formConfig[0].alwaysShowErrorMessage = false;
        }
    };
    KeycloakLogin.prototype.handleLoginError = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, summary, type, summary_1, transformedMessage;
            return __generator(this, function (_c) {
                _b = this.kcContext.message || {}, summary = _b.summary, type = _b.type;
                if (this.kcContext.message) {
                    summary_1 = this.kcContext.message.summary;
                    transformedMessage = translateCorexError(summary_1);
                    this.updateFormWithError((_a = translate("keycloak.corex.error." + transformedMessage)) !== null && _a !== void 0 ? _a : summary_1);
                }
                if (summary && type === 'error') {
                    getTrackingService().trackFailedLogin(this.submittedUsername, summary);
                }
                return [2 /*return*/];
            });
        });
    };
    KeycloakLogin.prototype.getInput = function (form, name) {
        return form.elements.namedItem(name);
    };
    KeycloakLogin.prototype.sendNotification = function (text) {
        return text;
    };
    /**
     * Handle form change events from the form builder
     */
    KeycloakLogin.prototype.onFormChange = function (event) {
        var changed = event.detail.changed;
        // Clear error when user starts typing
        if (changed &&
            (changed.id === 'username' || changed.id === 'password')) {
            this.clearFormError();
        }
    };
    /**
     * Handle form submission errors
     */
    KeycloakLogin.prototype.onFormSubmitError = function (error) {
        var errorMessage = (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred during login';
        this.updateFormWithError(errorMessage);
    };
    /**
     * Closes login page and redirects to home page
     */
    KeycloakLogin.prototype.onClose = function () {
        window.location.assign(this.redirectUri);
    };
    /**
     * Set a custom error message programmatically
     */
    KeycloakLogin.prototype.setErrorMessage = function (message) {
        this.updateFormWithError(message);
    };
    /**
     * Clear any existing error messages
     */
    KeycloakLogin.prototype.clearErrorMessage = function () {
        this.clearFormError();
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakLogin.prototype, "kcContext", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.SHOW_BACK_HOME_LINK_ON_LOGIN_PAGE,
            default: false,
        }),
        __metadata("design:type", Object)
    ], KeycloakLogin.prototype, "isBackHomeLinkAndIconEnabled", void 0);
    __decorate([
        Emit('notification'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], KeycloakLogin.prototype, "sendNotification", null);
    KeycloakLogin = __decorate([
        Component({
            name: 'corex-keycloak-login',
        })
    ], KeycloakLogin);
    return KeycloakLogin;
}(Mixins(MagicConfigMixin)));

export default KeycloakLogin;
